import React, { useState, useContext } from 'react'
import { Grid, Typography, Paper } from '@mui/material'
import custom from '../../../styles/mui/szVariables.json'
import { DataContext } from '../../../contexts/data/dataContext'

import ReferralItem from './referralItem'

function ReferralHistory() {
  const [openItemIndex, setOpenItemIndex] = useState<number | null>(null)
  const data = useContext(DataContext)
  const border = custom.border

  if (data?.customer?.referralHistory?.length === 0) {
    return null
  }

  const handleToggle = (index: number) => {
    setOpenItemIndex(openItemIndex === index ? null : index)
  }

  return (
    <>
      <Grid
        item
        xs={12}
        m={custom.spacing.md}
        mt={1}
        mb={1}
        display="flex"
        alignContent={'center'}
        justifyContent={'center'}
        alignItems={'center'}>
        <Paper
          id="referralHistory"
          elevation={0}
          sx={{
            borderRadius: custom.corners5,
            border,
            boxSizing: 'border-box',
            pt: 1,
            pb: 1,
            width: '100%',
          }}>
          {data?.customer?.referralHistory?.map((referral: any, index: number) => (
            <ReferralItem
              key={index}
              referral={referral}
              isOpen={openItemIndex === index}
              onToggle={() => handleToggle(index)}
              isLastItem={index === data?.customer?.referralHistory?.length - 1}
            />
          ))}
        </Paper>
      </Grid>
      <Grid
        item
        xs={12}
        px={custom.spacing.md}
        display="flex"
        justifyContent="center"
        alignItems="center"
        textAlign="center">
        <Typography variant="szBody.Regular.Small" sx={{ color: 'text.tertiary' }}>
          The referral amount will be available once the person you referred successfully installs and activates the
          solar system.
        </Typography>
      </Grid>
    </>
  )
}

export default ReferralHistory
